import { render, staticRenderFns } from "./FreightRate copy.vue?vue&type=template&id=48cfc8fa&scoped=true"
import script from "./FreightRate copy.vue?vue&type=script&lang=js"
export * from "./FreightRate copy.vue?vue&type=script&lang=js"
import style0 from "./FreightRate copy.vue?vue&type=style&index=0&id=48cfc8fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cfc8fa",
  null
  
)

export default component.exports